import {
  GetConsultantEventLogEvents,
  useGetSwitchesDataQuery,
  useUpdateUserSettingsMutation
} from "@bonliva-crm/graphql";
import locale from "@bonliva-crm/locale";
import { useSnackbars } from "@hooks";
import { Box, Switch, Typography, makeStyles } from "@material-ui/core";

type Props = {
  consultantId: string;
};

export function BankIdSwitch(props: Props) {
  const { showError } = useSnackbars();

  const { data } = useGetSwitchesDataQuery({
    variables: { id: props.consultantId },
    fetchPolicy: "cache-first"
  });

  const [bankIdMutation] = useUpdateUserSettingsMutation({
    onError: (error) => {
      showError(locale.cannotPerformAction);
      console.error(error);
    }
  });

  const setSigningBankId = (enabled: boolean) => {
    bankIdMutation({
      variables: {
        id: props.consultantId,
        input: { Enabled: enabled }
      },
      optimisticResponse: (vars) => {
        return {
          updateConsultantUserSettings: {
            ...data.consultantById,
            UserSettings: {
              __typename: "UserSettings",
              Enabled: vars.input.Enabled
            }
          }
        };
      },
      refetchQueries: [GetConsultantEventLogEvents.OperationName]
    });
  };

  const { root } = useStyles();
  return (
    <Box className={root}>
      <Switch
        disabled={!data?.consultantById.SocialSecurityNo}
        checked={data?.consultantById.UserSettings.Enabled ?? false}
        onChange={(_, value) => setSigningBankId(value)}
      />
      <Typography variant="body1" style={{ paddingTop: "2px" }}>
        {locale.canSignInUsingBankId}
      </Typography>
    </Box>
  );
}

const useStyles = makeStyles({
  root: {
    display: "flex",
    gap: "1rem",
    alignItems: "start"
  }
});
